import { inject, Injectable } from '@angular/core';
import { RequestBuilder } from '@hereisyourgitanton/crm-api2';
import { HttpClient, HttpParams } from '@angular/common/http';
import { NOTIFICATIONS_API_BASE_URL } from '../../api-base-url.token';
import { TradingProcedureNotificationResponseDto } from '../../schemas/trading-procedure-notifications-admin/trading-procedure-notification-response.dto';
import { TradingProcedureNotificationResponseItemsSegmentResponseDto } from '../../schemas/trading-procedure-notifications-admin/trading-procedure-notification-response-items-segment-response.dto';

export interface TradingProcedureNotificationsGetAllParams {
    Take?: number;
    Skip?: number;
    OrderBy?: string;
    /** Gridify filter syntax: https://alirezanet.github.io/Gridify/guide/filtering */
    Filter?: string;
}

@Injectable({ providedIn: 'root' })
export class TradingProcedureNotificationsAdminApi {
    private readonly builder = new RequestBuilder(inject(HttpClient));
    private readonly controllerUrl = `${inject(NOTIFICATIONS_API_BASE_URL)}/TradingProcedureNotificationsAdmin`;

    getAll(params: TradingProcedureNotificationsGetAllParams = {}) {
        let httpParams = new HttpParams();

        for (const [key, value] of Object.entries(params)) {
            if (value !== undefined && value !== null) {
                httpParams = httpParams.set(key, value);
            }
        }

        return this.builder
            .url(`${this.controllerUrl}/GetAll`)
            .get()
            .json<TradingProcedureNotificationResponseItemsSegmentResponseDto>()
            .withHttpParams(httpParams)
            .build()
            .send();
    }

    getById(id: string) {
        return this.builder
            .url(`${this.controllerUrl}/GetById`)
            .get()
            .json<TradingProcedureNotificationResponseDto>()
            .withHttpParams(new HttpParams().set('id', id))
            .build()
            .send();
    }
}
